import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { BookmarkAddedRounded, BookmarkAddOutlined } from '@mui/icons-material';
import { loginRequest } from '../../../../authConfig';
import colors from '../../../../scss/colors';
import MainButton from '../MainButton';

import { subTabs, tabs } from '../../../../Routes/jobs/jobTabs';
import { usePrevious } from '../../../../utils/hooks';
import { setNotification } from '../../../../actions/appNotifications';
import { appNotificationsTypes } from '../../../../utils/constants';
import classes from './saveButton.module.scss';

export default function SaveButton(props) {
  const { id, isSaved, saveDispatcher, unsaveDispatcher, saving = false, withDeleting = false } = props;

  const { t } = useTranslation();
  const { instance } = useMsal();
  const [searchParams] = useSearchParams();
  const isAuthenticated = useIsAuthenticated();
  const prevSaving = usePrevious(saving);
  const prevSaved = usePrevious(isSaved);
  const userId = localStorage.getItem('UserId');

  const dispatch = useDispatch();

  const saveHandler = () => {
    if (isAuthenticated) {
      dispatch(
        isSaved
          ? unsaveDispatcher(id, withDeleting)
          : saveDispatcher(
              id,
              userId,
              searchParams.get('subTab') === subTabs.SAVED && searchParams.get('tab') === tabs.MY_JOBS
            )
      );
    } else {
      localStorage.setItem('saveJobAfterLogin', JSON.stringify(id));
      instance
        .loginRedirect({
          ...loginRequest,
          redirectUri: `${window.location.origin}/dashboard/jobs`,
          state: JSON.stringify({ navigate: `/dashboard/jobs?id=${id}` })
        })
        .catch((e) => {
          console.error(e);
        });
    }
  };

  useEffect(() => {
    if (isSaved !== prevSaved && !saving && prevSaving) {
      dispatch(
        setNotification({
          type: appNotificationsTypes.SUCCESS,
          message: isSaved ? t('dashboard.jobs.jobwassaved') : t('dashboard.jobs.jobwasunsaved'),
          isAppStyled: true,
          duration: 3000,
          action: isSaved ? (
            <p
              role="presentation"
              className={classes.action}
              onClick={() => {
                window.location = `${window.location.origin}/dashboard/jobs?page=1&tab=${tabs.MY_JOBS}&subTab=${subTabs.SAVED}`;
              }}
            >
              {t('dashboard.jobs.seesavedjobs')}
            </p>
          ) : undefined
        })
      );
    }
  }, [saving]);

  let buttonIcon = <BookmarkAddedRounded sx={{ fontSize: '18px' }} />;
  if (saving) buttonIcon = <CircularProgress size="16px" sx={{ color: colors.NAVY_BLUE }} />;
  else if (!isSaved) buttonIcon = <BookmarkAddOutlined sx={{ fontSize: '18px' }} />;

  return (
    <MainButton outlined rounded action={saveHandler}>
      {buttonIcon}
      <div style={{ marginLeft: '10px' }}>{isSaved ? t('common.general.saved') : t('common.general.save')}</div>
    </MainButton>
  );
}
